import { __decorate } from "tslib";
import { html, css, SkhemataBase, property } from '@skhemata/skhemata-base';
export class SkhemataFormButton extends SkhemataBase {
    static get stlyes() {
        return [
            ...super.styles,
            css `
        .field {
          margin-bottom: 1rem;
          display: block;
        },
      `,
        ];
    }
    title = '';
    color = '';
    type = '';
    valid = true;
    helpClass = '';
    handleClick() {
        if (this.type === 'submit') {
            this.dispatchEvent(new CustomEvent('submit'));
        }
        else {
            this.dispatchEvent(new Event('click'));
        }
    }
    render() {
        return html `
      <button
        class="button is-fullwidth is-primary"
        style=${this.color ? `background-color: ${this.color}` : ''}
        @click=${this.handleClick}
      >
        ${this.title}
      </button>
    `;
    }
}
__decorate([
    property({ type: String })
], SkhemataFormButton.prototype, "title", void 0);
__decorate([
    property({ type: String })
], SkhemataFormButton.prototype, "color", void 0);
__decorate([
    property({ type: String })
], SkhemataFormButton.prototype, "type", void 0);
__decorate([
    property({ type: Boolean })
], SkhemataFormButton.prototype, "valid", void 0);
__decorate([
    property({ type: String })
], SkhemataFormButton.prototype, "helpClass", void 0);
//# sourceMappingURL=SkhemataFormButton.js.map